import React from 'react';

const Gmail: React.FC<{ height?: number; width?: number }> = ({
  height,
  width,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" fill="#FFF" />
      <g clip-path="url(#clip0_206_14956)">
        <path d="M22 2H2V22H22V2Z" fill="#FFF" />
        <path
          d="M4.29171 18.875H19.7084C20.5138 18.875 21.1667 18.2221 21.1667 17.4167V6.58333C21.1667 5.77792 20.5138 5.125 19.7084 5.125H4.29171C3.48629 5.125 2.83337 5.77792 2.83337 6.58333V17.4167C2.83337 18.2221 3.48629 18.875 4.29171 18.875Z"
          fill="#E0E0E0"
        />
        <path
          d="M12.8334 18.875H19.7084C20.5138 18.875 21.1667 18.2221 21.1667 17.4167V6.58333C21.1667 5.77792 20.5138 5.125 19.7084 5.125H4.29171C3.48629 5.125 2.83337 5.77792 2.83337 6.58333L12.8334 18.875Z"
          fill="#D9D9D9"
        />
        <path
          d="M4.81042 18.8753H19.7083C20.5138 18.8753 21.1667 18.2224 21.1667 17.417V6.79199L4.81042 18.8753Z"
          fill="#EEEEEE"
        />
        <path
          d="M12.7272 18.8753H19.7085C20.5139 18.8753 21.1668 18.2224 21.1668 17.417V6.79199L9.82141 15.1737L12.7272 18.8753Z"
          fill="#E0E0E0"
        />
        <path
          d="M19.7084 5.95868H4.29171C3.48629 5.95868 2.83337 5.77826 2.83337 6.58366V17.417C2.83337 18.2224 3.48629 18.8753 4.29171 18.8753H4.91671V7.00032H19.0834V18.8753H19.7084C20.5138 18.8753 21.1667 18.2224 21.1667 17.417V6.58366C21.1667 5.77826 20.5138 5.95868 19.7084 5.95868Z"
          fill="#CA3737"
        />
        <path
          d="M19.7084 5.125H12H4.29171C3.48629 5.125 2.83337 5.765 2.83337 6.58333C2.83337 7.08583 3.46587 7.52417 3.46587 7.52417L12 13.565L20.5342 7.52458C20.5342 7.52458 21.1667 7.08583 21.1667 6.58375C21.1667 5.765 20.5138 5.125 19.7084 5.125Z"
          fill="#F5F5F5"
        />
        <path
          d="M20.0192 5.15918L12 10.75L3.98087 5.15918C3.32504 5.2996 2.83337 5.87376 2.83337 6.58333C2.83337 7.08583 3.46587 7.52417 3.46587 7.52417L12 13.565L20.5342 7.52458C20.5342 7.52458 21.1667 7.08583 21.1667 6.58375C21.1667 5.87376 20.675 5.2996 20.0192 5.15918Z"
          fill="#E84F4B"
        />
      </g>
      <defs>
        <clipPath id="clip0_206_14956">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Gmail;
